import styled from 'styled-components'

export const ChartContainer = styled.div`
    .recharts-tooltip-wrapper {
        outline: none;
        ${({ theme }) => theme.fonts.Karla['s16-ln20-fw700']};
    }
    border-radius: 5px;
    border: var(--dashboard-legend-border);
    padding: 10px 20px;
    background-color: var(--dashboard-basic-background-color);
`

export const TooltipContainer = styled.div`
    background-color: var(--dashboard-basic-background-color);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 10px;
    transform: translateY(-100px);
    ul {
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        li {
            list-style: none;
            padding: 0;
            margin: 0;
            p {
                ${({ theme }) => theme.fonts.Karla['s16-ln20-fw400']};
                display: block;
                font-weight: normal;
                padding: 0;
                margin: 4px;
            }
        }
    }
`

export const LegendWrapper = styled.div`
    padding-bottom: 10px;
`

export const LegendTitle = styled.div`
    margin: 0;
    padding: 0;
    ${({ theme }) => theme.fonts.Karla['s20-ln26-fw800']};
`

export const LegendLabel = styled.div`
    margin: 0 0 5px 0;
    padding: 0;
    ${({ theme }) => theme.fonts.Karla['s18-ln24-fw400']};
    color: ${(props) => props.theme.colors.monochrome.graphite};
`

export const LegendItem = styled.span`
    margin-right: 10px;
    ${({ theme }) => theme.fonts.Karla['s16-ln20-fw400']};
`
